
export const uzLanguage=()=>{
    return {
        type:'uz',
    }

};